var map = {
	"./andalucia.jpg": 2824,
	"./aragon.jpg": 8110,
	"./asturias.jpg": 4674,
	"./baleares.jpg": 8055,
	"./canarias.jpg": 8652,
	"./cantabria.jpg": 4907,
	"./castilla-la-mancha.jpg": 6216,
	"./castilla-y-leon.jpg": 234,
	"./cataluna.jpg": 1491,
	"./ceuta.jpg": 346,
	"./extremadura.jpg": 48,
	"./galicia.jpg": 7156,
	"./la-rioja.jpg": 8159,
	"./madrid.jpg": 5067,
	"./melilla.jpg": 3502,
	"./murcia.jpg": 797,
	"./navarra.jpg": 1419,
	"./pais-vasco.jpg": 8338,
	"./valencia.jpg": 3597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3899;